import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { Viewable, PromiseCompletionSource } from "scene-manager";
import { PreloaderResourcesPackage } from "./resources/PreloaderResourcesPackage";
import { PreloaderView } from "./views/PreloaderView";
import { PreloaderModel } from "./models/PreloaderModel";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { PreloaderController } from "./controllers/PreloaderContorller";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { FontResourcesPackage } from "../../common/resources/FontResourcesPackage";
import { BackgroundResourcesPackage } from "../../common/resources/BackgroundResourcesPackage";

@injectable()
export class PreloaderScene extends Viewable<void> {

    public constructor(
        private readonly backgroundResources: BackgroundResourcesPackage,
        private readonly fontResources: FontResourcesPackage,
        private readonly preloaderModel: PreloaderModel,
        @inject(InjectableInterfaces.ICanvasScaler) 
        private readonly canvasScaler: ICanvasScaler,
        private readonly preloaderController: PreloaderController,
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const preloaderResources = new PreloaderResourcesPackage();
        await Promise.all([this.fontResources.load(), this.backgroundResources.load(), preloaderResources.load()]);
        const viewCanBeClosed = new PromiseCompletionSource<void>();
        this.view = new PreloaderView(
            this.backgroundResources,
            preloaderResources,
            this.preloaderModel,
            this.preloaderController,
            this.canvasScaler,
            viewCanBeClosed
        );
        viewCanBeClosed.result.then(async () => {
            preloaderResources.destroy();
            this.operationControls.complete();
        });
    }
}
